import GenericBoard from "../Generic/GenericBoard"
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Task } from "../../model/task.model";
import { getTasksByUserId, getAllTaskFromServer, addTask } from "../../api/task.api";
import './task.css';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { User } from "../../model/user.model";
import { setAllUsers } from "../../Redux/User/userAction";
import { getUsers } from "../../api/user.api";
import { Enum } from '../../model/enum.model';
import Swal from "sweetalert2";
import ReactDOM from "react-dom";
import { Project } from "../../model/project.model";
import { TaskCategory } from "../../model/taskCategory.model";
import AddTaskForm from "./addTask.component";
import GenericTab from "../Generic/GenericTab";
import { setAllProject } from "../../Redux/Project/projectAction";
import { getProject } from "../../api/project.api";
import { setAllTaskStatus } from "../../Redux/enum/taskStatusAction";
import { getAllEnumFromServer } from "../../api/enum.api";
import { setAllEnums } from "../../Redux/enum/enumAction";
import { setAllTaskCategory } from "../../Redux/tasx/taskCategoryAction";
import { getTaskCategories } from "../../api/taskCategory.api";
import { Modal, Box } from '@mui/material';
import ChatTable from "./chat";
import TaskInfo from "./TaskInfo";
const Tasks: React.FC<{}> = () => {
  const dispatch = useDispatch();
  const [levelUrgencyStatus, setLevelUrgencyStatus] = useState<Enum[]>([]);
  const [taskStatus, setTaskStatus] = useState<Enum[]>([]);
  const [project, setProject] = useState<Project[]>([]);
  const [tasks, setTasks] = useState<Task[]>([]);
  const [selectedTaskId, setSelectedTaskId] = useState<string>("");
  const [taskCategory, setTaskCategory] = useState<TaskCategory[]>([])
  // const [tasks, setTasks] = useState<{ [key: string]: Task[] }>({});
  const [users, setUsers] = useState<User[]>([]);

  const projectState = useSelector((state: { Project: { allProject: { [key: string]: Project[] } } }) => state.Project);
  const taskStatusState = useSelector((state: { taskStatus: { allTaskStatus: { [key: string]: Enum[] } } }) => state.taskStatus);
  const levelState = useSelector((state: { LevelUrgencyStatus: { allEnums: { [key: string]: Enum[] } } }) => state.LevelUrgencyStatus);
  const [ref, setRef] = useState(false);
  const currentUser = useSelector((state: { user: { currentUser: any } }) => state.user.currentUser);
  const [view, setView] = useState("board");
  const [searchTerm, setSearchTerm] = useState('');
  const [showSearch, setShowSearch] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const config = {
    categoryField: "status.value",
    categories: [
      { label: "ממתינה לטיפול", color: "#2c6d8f" },
      { label: "בביצוע", color: "#2c6d8f" },
      { label: "בהמתנה", color: "#2c6d8f" },
      { label: "בוצע", color: "#2c6d8f" }
    ],
    displayFields: [
      { key: "taskName", label: "שם" },
      {
        key: "assignedTo",
        label: "אחראית",
        lookup: "users",
        lookupLabel: "firstName,lastName"
      },
      {
        key: "projectId",
        label: "פרויקט",
        lookup: "projects",
        lookupLabel: "name"
      },
      { key: "startDate", label: "תאריך", format: "date" },
      { key: "levelUrgencyStatus", label: "רמת דחיפות" },
    ],
    actionLabel: "פרטים",
    idField: "taskId"
  };
  const configTab = {
    categoryField: "status.value",
    categories: [
      { label: "ממתינה לטיפול", color: "#2c6d8f" },
      { label: "בביצוע", color: "#2c6d8f" },
      { label: "בהמתנה", color: "#2c6d8f" },
      { label: "בוצע", color: "#2c6d8f" }
    ],
    displayFields: [
      { key: "taskName", label: "שם" },
      {
        key: "assignedTo",
        label: "אחראית",
        lookup: "users",
        lookupLabel: "firstName,lastName"
      },
      {
        key: "projectId",
        label: "פרויקט",
        lookup: "projects",
        lookupLabel: "name"
      }, { key: "status.value", label: "סטטוס" },
      { key: "startDate", label: "תאריך", format: "date" },
      { key: "levelUrgencyStatus", label: "רמת דחיפות" },

    ],
    actionLabel: "פרטים"
  };
  useEffect(() => {
    fetchDataUser();
    fetchDataLevel();
    fetchDataProject();
    fetchDatastatus();
    fetchTaskCategory();
  }, []);
  useEffect(() => {
    if (currentUser && currentUser.id) {
      fetchDataTask();
    }
  }, [currentUser]);
  useEffect(() => {
    if (!currentUser || !currentUser.id) {
      const savedUser = sessionStorage.getItem("userId");
      if (savedUser) {
        const restoredUser = {
          id: sessionStorage.getItem("userId"),
          firstName: sessionStorage.getItem("firstName"),
          lastName: sessionStorage.getItem("lastName"),
          email: sessionStorage.getItem("email"),
          userType: {
            description: sessionStorage.getItem("userType")
          }
        };
        dispatch({ type: "SET_CURRENT_USER", payload: restoredUser });
      }
    }
  }, [dispatch]);
  const fetchDataUser = async () => {
    let data;
    const resAllUsers = await getUsers();
    data = resAllUsers;
    dispatch(setAllUsers(data));
    setUsers(data);
  };
  const fetchTaskCategory = async () => {
    let data;
    const resAllTaskCategory = await getTaskCategories();
    data = resAllTaskCategory;
    dispatch(setAllTaskCategory(data));
    setTaskCategory(data);
  };
  const fetchDataLevel = async () => {
    try {
      let data;
      if (levelState.allEnums.length) {
        data = levelState.allEnums;
      }
      else {
        const resAllLevel = await getAllEnumFromServer(6);
        data = resAllLevel;
        dispatch(setAllEnums(resAllLevel));
        console.log("resAllLevel", resAllLevel)
      }
      setLevelUrgencyStatus(data);
    }
    catch (error) {
      console.error('Error fetching task:', error);
    }
  }
  const fetchDatastatus = async () => {
    try {
      let data;
      console.log(taskStatusState.allTaskStatus);
      if (taskStatusState.allTaskStatus.length) {
        data = taskStatusState.allTaskStatus;
      }
      else {
        const resAllStatus = await getAllEnumFromServer(3);
        data = resAllStatus;
        dispatch(setAllTaskStatus(resAllStatus));
      }
      console.log("resAllStatus", data);
      setTaskStatus(data);
    }
    catch (error) {
      console.error('Error fetching task:', error);
    }
  }
  const fetchDataProject = async () => {
    try {
      let data;
      console.log(projectState.allProject);
      if (projectState.allProject.length) {
        data = projectState.allProject;
      }
      else {
        const resAllproject = await getProject();
        data = resAllproject.data;
        console.log("resAllproject", data);
        dispatch(setAllProject(resAllproject));
      }
      setProject(data);
    }
    catch (error) {
      console.error('Error fetching task:', error);
    }
  }
  const handleAddTask = () => {
    Swal.fire({
      title: 'הוספת משימה חדשה',
      html: '<div id="add-task-container"></div>',
      showCloseButton: true,
      showCancelButton: false,
      showConfirmButton: false,
      didOpen: () => {
        const container = document.getElementById('add-task-container');
        if (container) {
          ReactDOM.render(
            <AddTaskForm
              levelUrgencyStatus={levelUrgencyStatus}
              setTasks={setTasks}
              taskStatus={taskStatus}
              user={users}
              project={project}
              taskCategory={taskCategory}
              handleTaskAdded={async (newTask: Task) => {
                try {
                  const response = await addTask(newTask);
                  console.log("response from server:", response);
                  const completedTask: Task = {
                    ...newTask,
                    taskId: response
                  };
                  console.log("completedTask:", completedTask);
                  const statusKey = newTask.status?.value || "ללא סטטוס";
                  setTasks(prevTasks => ({
                    ...prevTasks,
                    [statusKey]: [...(prevTasks[statusKey] || []), completedTask]
                  }));
                  Swal.fire('Success', 'המשימה נוספה בהצלחה', 'success');
                } catch (error) {
                  console.error("Error adding task:", error);
                  Swal.fire('Error', 'שגיאה בהוספת המשימה', 'error');
                }
              }}
            />,
            container
          );
        }
      },
    });
  };
  const fetchDataTask = async () => {
    try {
      let res;
      if (currentUser.userType.description === "מנהל") {
        res = await getAllTaskFromServer();
        console.log("Tasks from server:", res);
      } else {
        res = await getTasksByUserId(currentUser?.id);
      }

      // מיון המשימות לפי תאריך (האחרונות ראשונות)
      const sortedTasks = res.sort((a, b) => new Date(b.startDate).getTime() - new Date(a.startDate).getTime());

      // קיבוץ לפי סטטוס
      const grouped = sortedTasks.reduce((acc, task) => {
        const key = task.Status?.Value || "ללא סטטוס"; // גיבוי אם חסר
        if (!acc[key]) acc[key] = [];
        acc[key].push(task);
        return acc;
      }, {});

      setTasks(grouped);
    } catch (error) {
      console.error("Error fetching tasks:", error);
    }
  };

  console.log("Data passed to GenericBoard:", Object.values(tasks).flat());
  const filteredTasks = Object.values(tasks).flat().filter((task) => {
    const assignedUser = users.find(u => u.id === task.assignedTo);
    const combined = [
      task.taskName,
      assignedUser?.firstName,
      assignedUser?.lastName,
      task.status?.value,
    ]
      .join(" ")
      .toLowerCase();
    return combined.includes(searchTerm.toLowerCase());
  });
  const openTaskPopup = (taskId: number) => {
    setSelectedTaskId(String(taskId));
    setModalOpen(true);
  };
  return (
    <div>
      {/* טאבים למעבר בין תצוגות */}
      <div className="tabs-container">
        <div
          className={`tab ${view === "board" ? "active" : ""}`}
          onClick={() => setView("board")}
        >
          לוח
        </div>
        <div
          className={`tab ${view === "list" ? "active" : ""}`}
          onClick={() => setView("list")}
        >
          רשימה
        </div>
      </div>
      <div className="task-top-section">
        <div className="user-profile">
          <AccountCircle sx={{ width: 30, height: 30, marginLeft: '8px' }} />
          <span>{currentUser?.firstName} {currentUser?.lastName}</span>
        </div>
        <div className="task-header">
          <div className="right-section">
            {currentUser?.userType?.description === "מנהל" && (
              <button className="add-lead-button" onClick={handleAddTask}>
                +<span className='add'>להוספת משימה</span>
              </button>
            )}
          </div>
          <div className="center-section">
            <h1 className="task-title">משימות</h1>
          </div>
          <div className="left-section">
            <button
              className="search-toggle"
              onClick={() => setShowSearch(!showSearch)}
              title="חיפוש"
            >
              <svg xmlns="http://www.w3.org/2000/svg" height="50" viewBox="0 0 24 24" width="50" fill="#2c3e50">
                <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C8.01 14 6 11.99 6 9.5S8.01 5 10.5 5 15 7.01 15 9.5 12.99 14 10.5 14z" />
              </svg>
            </button>
            {showSearch && (
              <input
                type="text"
                placeholder="חיפוש..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-line-inline"
                autoFocus
              />
            )}
          </div>
        </div>
      </div>
      {/* תצוגה בהתאם לטאב הנבחר */}
      <div>
        {view === "board" ? (
          <GenericBoard data={filteredTasks}
            config={config}
            openItemPopup={openTaskPopup}
            lookups={{
              users: users.map(u => ({
                id: u.id,
                firstName: u.firstName,
                lastName: u.lastName
              })),
              projects: project.map(p => ({
                id: p.projectId,
                name: p.businessName
              }))
            }}
          />
        ) : (
          <GenericTab
            data={filteredTasks}
            config={configTab}
            openItemPopup={openTaskPopup}
            lookups={{
              users: users.map(u => ({
                id: u.id,
                firstName: u.firstName,
                lastName: u.lastName
              })),
              projects: project.map(p => ({
                id: p.projectId,
                name: p.businessName
              }))
            }}

          />
        )}
      </div>
      {modalOpen && (
        <Modal key={selectedTaskId} open={modalOpen} onClose={() => setModalOpen(false)} >
          <Box
            sx={{
              backgroundColor: '#fff',
              display: "flex",
              flexDirection: 'row',
              padding: '20px',
              borderRadius: '10px',
              // border: '1px solid #ccc',
              // boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
              width: '80%',
              height: "60%",
              top: "50%",
              left: "50%",
              position: 'absolute',
              direction: 'rtl',
              transform: 'translate(-50%, -50%)'
            }}
          >
            {selectedTaskId && (
              <>
                <TaskInfo
                  selectedTaskId={selectedTaskId}
                  refresh={fetchDataTask}
                  onClose={() => setModalOpen(false)}
                />
                <ChatTable itemId={selectedTaskId}></ChatTable>
              </>
            )}
          </Box>
        </Modal>
      )}
    </div>
  );
};
export default Tasks;
